export const fixedFeeSearchPlaceholder = 'Pesquise por nome, conta ou CPF/CNPJ';
export const fixedFeeTermsEmptyState = 'Não encontramos resultados para os critérios informados.';
export const fixedFeeTermsNoRequestsState =
  'No momento, você ainda não possui nenhum cliente com o modelo de Fee Fixo contratado.';
export const fixedFeeUnavailableState = `Esta tela só pode ser acessada pelo próprio assessor.\nVolte à sua filial inicial e selecione seu acesso.`;
